<div class="page-header">
  <div>
    <h1>Auditlog</h1>
    <p>Nachvollziehbare Verwaltungsaktionen im Portal.</p>
  </div>
</div>

<section class="panel section-stack">
  <div class="filter-bar">
    <label>
      <span>Suche</span>
      <input type="search" placeholder="Beschreibung, Benutzer oder Ziel" [value]="search()" (input)="setSearch($event)" (keydown.enter)="applyFilters()">
    </label>

    <label>
      <span>Aktion</span>
      <select [value]="action()" (change)="setAction($event)">
        <option value="">Alle</option>
        <option value="LOGIN">Login</option>
        <option value="LOGOUT">Logout</option>
        <option value="LOGIN_FAILED">Login fehlgeschlagen</option>
        <option value="ORGANIZATION_CREATED">Organisation angelegt</option>
        <option value="ORGANIZATION_UPDATED">Organisation aktualisiert</option>
        <option value="ORGANIZATION_DELETED">Organisation gelöscht</option>
        <option value="COMPANY_CREATED">Unternehmer angelegt</option>
        <option value="COMPANY_UPDATED">Unternehmer aktualisiert</option>
        <option value="COMPANY_DELETED">Unternehmer gelöscht</option>
        <option value="DRIVER_CREATED">Fahrer angelegt</option>
        <option value="DRIVER_UPDATED">Fahrer aktualisiert</option>
        <option value="DRIVER_DELETED">Fahrer gelöscht</option>
        <option value="COURSE_ASSIGNED">Schulung zugewiesen</option>
        <option value="LESSON_COMPLETED">Lektion abgeschlossen</option>
        <option value="QUIZ_STARTED">Quiz gestartet</option>
        <option value="QUIZ_PASSED">Quiz bestanden</option>
        <option value="QUIZ_FAILED">Quiz nicht bestanden</option>
        <option value="CERTIFICATE_ISSUED">Zertifikat ausgestellt</option>
        <option value="CERTIFICATE_REVOKED">Zertifikat widerrufen</option>
        <option value="RETRAINING_ASSIGNED">Nachschulung zugewiesen</option>
        <option value="RETRAINING_COMPLETED">Nachschulung abgeschlossen</option>
        <option value="PAYMENT_INITIATED">Zahlung gestartet</option>
        <option value="PAYMENT_COMPLETED">Zahlung abgeschlossen</option>
        <option value="PAYMENT_FAILED">Zahlung fehlgeschlagen</option>
        <option value="PAYMENT_RETURNED">Zur Anwendung zurückgekehrt</option>
        <option value="VIDEO_WATCHED">Video angesehen</option>
      </select>
    </label>

    <button type="button" class="primary-button" (click)="applyFilters()">Filtern</button>
    <button type="button" class="ghost-button" (click)="reset()">Zurücksetzen</button>
  </div>

  @if (loading()) {
    <div class="info-message">Auditlog wird geladen.</div>
  }

  @if (logs(); as page) {
    <table class="table">
      <thead>
        <tr>
          <th>Zeitpunkt</th>
          <th>Aktion</th>
          <th>Beschreibung</th>
          <th>Benutzer</th>
          <th>Ziel</th>
        </tr>
      </thead>
      <tbody>
        @for (log of page.items; track log.id) {
          <tr>
            <td>{{ formatDate(log.createdAt) }}</td>
            <td><span class="badge">{{ actionLabel(log.action) }}</span></td>
            <td>{{ valueOrDash(log.description) }}</td>
            <td>
              <strong>{{ valueOrDash(log.actorName) }}</strong><br>
              <span>{{ valueOrDash(log.actorEmail) }}</span>
            </td>
            <td>{{ target(log) }}</td>
          </tr>
        } @empty {
          <tr>
            <td colspan="5">Keine Auditlog-Einträge gefunden.</td>
          </tr>
        }
      </tbody>
    </table>

    <div class="pager-bar">
      <div class="result-pill">{{ page.total }} Einträge · Seite {{ page.page + 1 }} von {{ totalPages(page) }}</div>
      <div class="pager-controls">
        <label>
          <span>Zeilen pro Seite</span>
          <select [value]="pageSize()" (change)="setPageSize($event)">
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </label>

        <div class="toolbar-actions">
          <button type="button" class="ghost-button" (click)="previousPage()" [disabled]="loading() || !hasPrevious(page)">Zurück</button>
          <button type="button" class="ghost-button" (click)="nextPage()" [disabled]="loading() || !hasNext(page)">Weiter</button>
        </div>
      </div>
    </div>
  } @else if (!loading()) {
    <div class="empty">Auditlog wird geladen.</div>
  }
</section>
  
